import { PiShieldCheck, PiCheckBold, PiLock } from 'react-icons/pi'

import { AutoUnsubscribeSettings } from './AutoUnsubscribeSettings'

const OPT_OUT_SAFETY_ITEMS = [
  {
    title: 'Enable opt-out handling',
    description: 'Process unsubscribe requests automatically',
  },
  {
    title: 'Auto-remove unsubscribes',
    description: 'Immediately stop sending to contacts who unsubscribe',
  },
  {
    title: 'Stop sequence on reply',
    description: 'Stop sending follow-ups when a contact replies',
  },
  {
    title: 'Bounce detection',
    description:
      'Hard bounces stop the sequence immediately. High bounce rates temporarily pause sending to protect your domain.',
  },
] as const

export function SequencingSettings() {
  return (
    <div className="flex-1 overflow-auto bg-[#fefefe]">
      <div className="max-w-2xl mx-auto px-8 py-8">
        <div className="mb-8">
          <h2 className="text-xl font-semibold text-fg">Sequencing</h2>
          <p className="text-gray-500 text-sm mt-1">
            These settings apply to all campaigns. Changes here affect every
            active and future campaign.
          </p>
        </div>

        <div className="space-y-6">
          <div className="bg-surface rounded-xl border border-line p-5 shadow-[0px_1px_3px_0px_rgba(16,24,40,0.08),0px_1px_2px_-1px_rgba(16,24,40,0.04)]">
            <AutoUnsubscribeSettings />
          </div>

          {/* Opt-Out & Safety */}
          <div className="bg-surface rounded-xl border border-line p-5 shadow-[0px_1px_3px_0px_rgba(16,24,40,0.08),0px_1px_2px_-1px_rgba(16,24,40,0.04)]">
            <div className="flex items-center gap-3 mb-4">
              <div className="size-10 rounded-lg bg-brand-active/10 flex items-center justify-center">
                <PiShieldCheck size={20} className="text-brand-active" />
              </div>
              <div>
                <h3 className="text-lg font-semibold text-fg">
                  Opt-Out & Safety
                </h3>
                <p className="text-sm text-gray-500">
                  Global protection settings for all campaigns
                </p>
              </div>
            </div>
            <div className="space-y-1">
              {OPT_OUT_SAFETY_ITEMS.map((item, index) => (
                <div
                  key={item.title}
                  className={`flex items-start justify-between py-3 ${
                    index < OPT_OUT_SAFETY_ITEMS.length - 1
                      ? 'border-b border-line'
                      : ''
                  }`}
                >
                  <div className="flex-1">
                    <div className="flex items-start gap-3">
                      <div className="size-5 rounded-full bg-brand-active flex items-center justify-center shrink-0 mt-0.5">
                        <PiCheckBold size={12} className="text-white" />
                      </div>
                      <div className="flex-1">
                        <p className="text-sm text-fg">{item.title}</p>
                        <p className="text-xs text-gray-500">
                          {item.description}
                        </p>
                      </div>
                    </div>
                  </div>
                  <PiLock size={16} className="text-gray-500 ml-3 mt-0.5" />
                </div>
              ))}
            </div>
          </div>
        </div>
      </div>
    </div>
  )
}
